export default {
    MINUTOS: 1,
    HORAS: 2,
    DIAS: 3,
    SEMANAS: 4,
    MESES: 5,
    ANOS: 6,
}